import { isNullOrUndefined } from '@/features/shared/tools'
import type { DropdownItem } from '@designSystem/components/basic'

export const boolDropDownItems: DropdownItem<boolean>[] = [
  { id: true, label: 'Oui' },
  { id: false, label: 'Non' },
]

export function getLabelBoolean(value?: boolean | null): string | undefined {
  if (isNullOrUndefined(value)) return undefined

  return value === true ? 'Oui' : 'Non'
}
